import React, { useEffect, useState } from "react";

//Style
import "./SalesforceBgScreen.css";

const SalesforceBgScreen = () => {
  const [currentImg, setCurrentImg] = useState(
    "https://pagina-cavca-seguros.s3.amazonaws.com/main-page/salesforce-bg/standard-salesforce-login-bg.webp"
  );

  useEffect(() => {
    const currentDate = new Date();
    const currentMonth = currentDate.getMonth() + 1;

    if (currentMonth === 5) {
      // Si es mayo (el mes de las madres)
      setCurrentImg(
        "https://pagina-cavca-seguros.s3.amazonaws.com/main-page/salesforce-bg/mom-day-salesforce.bg.webp"
      );
    }
  }, []);

  return (
    <div className="salesforce-bg-container">
      <img className="sb-img" src={currentImg} alt="" />
    </div>
  );
};

export default SalesforceBgScreen;
